export type BlogFilters = { collection: string; topic: string };

export function matchesBlogFilters(
  post: { category: string; badges?: readonly string[] },
  filters: BlogFilters,
): boolean {
  return (
    (filters.collection === "all" || !!post.badges?.includes(filters.collection)) &&
    (filters.topic === "all" || post.category === filters.topic)
  );
}
